module.exports = __webpack_public_path__ + "img/info.8123b329.svg";